/**
 * The root error page (mission 7 WP08 T046; FR-026, US11.2; TEN.11; research
 * §1.25; known-followups "A throw in AppShell, AuthGate or the credit chip";
 * contracts/ui-api.md "Spine, part 2").
 *
 * routes.tsx mounts this as the errorElement of a pathless layout route that
 * wraps the whole tree. A screen's throw stays inside the shell (the /app
 * layout's errorElement, AppFallback.tsx). A throw in AppShell, AuthGate or the
 * credit chip throws again inside that errorElement, and lands here: a plain
 * page with no shell and no gate, so nothing that just failed renders again.
 *
 * It states what happened with register 16's `renderErrorTitle` and
 * `renderError`, and links to runs with `backToRuns`. The link is a plain
 * anchor, so following it reloads the app and starts from a fresh cache rather
 * than re-rendering the state that threw. The error is never read, rendered or
 * logged here: it may carry a value the reporter uploaded (TEN.11).
 */
import { APP_HOME } from '@/components/trellis/AuthGate'
import { copyText } from '@/lib/provisional-copy'

export default function RootError() {
  return (
    <main className="mx-auto flex max-w-2xl flex-col gap-4 px-8 py-16">
      <h1 className="text-h1 text-navy-950">{copyText('renderErrorTitle')}</h1>
      <p className="text-body text-navy-700">{copyText('renderError')}</p>
      <p>
        <a href={APP_HOME} className="text-body text-[var(--color-link)] hover:underline">
          {copyText('backToRuns')}
        </a>
      </p>
    </main>
  )
}
